import { SEO } from "custom-types/Directus";

const ProductsCopyBlocks: React.FC<{ blocks?: SEO["copyBlocks"] }> = ({
  blocks,
}) =>
  blocks?.length ? (
    <>
      {blocks.map((block) => (
        <section className="mt-section" key={block.title}>
          <h2 className="mb-sm">{block.title}</h2>
          <div
            className="dangerously-set-html"
            dangerouslySetInnerHTML={{ __html: block.text || "" }}
          />
        </section>
      ))}
    </>
  ) : (
    <></>
  );
export default ProductsCopyBlocks;
